// @flow
import * as React from 'react';
import { Row, Col, Container } from 'reactstrap';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

import Panel from 'components/atoms/Panel';
import Button from 'components/atoms/Button';
import ParseHTML from 'components/atoms/ParseHTML';

import './Reminder.scss';

const ns = 'self-checkin-reminder-confirmation';
const md = 'middle';
export type Props = {
  intl: IntlShape,
  closeConfirmationModal: Function,
  selfCheckInFlow: string
};

const Reminder = (props: Props) => {
  // ToDo: Remove default message when localization string is ready
  const { intl, closeConfirmationModal } = props;
  const disclaimer = intl.formatMessage({
    id: 'c8.self.check.in.config.drop.keys.instructions',
    defaultMessage:
      '<ul>' +
      '<li>Parking is open except for the Service Drive Lane</li>' +
      '<li>Keys can be dropped off with any advisor or in the service department drop box</li>' +
      '<li>To speak with a service advisor, complete checking in and indicate your preferred method of contact</li>' +
      '</ul>'
  });
  return (
    <Container className={`${ns}`}>
      <Row>
        <Col xs={12} className={`${ns}__${md}--title`}>
          {intl.formatMessage({
            id:
              'c8.self.check.in.confirmation.page.modal.remember.drop.your.keys',
            defaultMessage:
              'Remember to drop your keys off before leaving the dealership'
          })}
        </Col>
      </Row>
      <Panel>
        <ParseHTML className={`${ns}__paragraphs`} html={disclaimer} />
        <Button
          onClick={() => {
            closeConfirmationModal && closeConfirmationModal();
          }}
        >
          {intl.formatMessage({
            id: 'c8.self.check.in.confirmation.page.ok',
            defaultMessage: 'OK'
          })}
        </Button>
      </Panel>
    </Container>
  );
};

export default Reminder;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ConfirmationPage/components/Reminder/Reminder.js